export default "__VITE_ASSET__C$QuW6tQ__"